/**
 * 候補者ステータスの表示名。従業員インタビューの候補者一覧と、ステークホルダーの回答依頼で共用する。
 *
 * 「送信済み」ではなく「未予約」と呼ぶのは、運用で知りたいのが送った事実ではなく
 * 予約がまだ入っていないことだから。モックの語彙に合わせている。
 */
export const CANDIDATE_STATUS_LABELS: Record<string, string> = {
  UNSENT: "未送信",
  SENT: "未予約",
  BOOKED: "予約確定",
  COMPLETED: "実施済み",
};

export const CANDIDATE_STATUS_CLASSES: Record<string, string> = {
  UNSENT: "bg-[var(--color-bg-subtle-gray)] text-[var(--color-text-secondary)]",
  SENT: "bg-[#dbeafe] text-[#1e40af]",
  BOOKED: "bg-[#dcfce7] text-[#166534]",
  COMPLETED: "bg-[#dcfce7] text-[#166534]",
};

export const CANDIDATE_STATUS_UNSENT = "UNSENT";
